var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.info.info))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }